import React from 'react';
import ReactDOM from 'react-dom';
import { loadable } from '../../components/loadable';

export const LoadableProfileLink = loadable(
  () => import(/* webpackChunkName: 'CourseProgressBar' */ './ProfileLink'),
  {
    key: 'HotConnectedProfileLink',
  }
);

export const ProfileLinkPortal = () => {
  const elem = document.getElementById('user-profile-link-mount');
  if (elem) {
    return ReactDOM.createPortal(<LoadableProfileLink />, elem);
  } else {
    return null;
  }
};
